export const cartdatareq="cartdatareq"
export const cartdatasucc="cartdatasucc"
export const cartdatafail="cartdatafail"